module.exports = __webpack_public_path__ + "media/images/image1-42c1f878f916e53fd6c6796fddcc558a.png";